<template>
  <div class="flex-column">
    <div v-if="showTitle" class="propject_detail_info_header flex-row item-center col-0">
      <span class="propject_detail_info_header_primary mr5">
        <a @click="showCompany(project['客户公司'])">{{ project['客户公司'] }}</a> -
        {{ project['部门'] ? `${project['部门']} - ` : '' }}{{ project['项目名称'] }}
      </span>
      <el-rate
        v-if="project['优先级']"
        v-model="project['优先级']"
        :colors="['#99A9BF', '#F7BA2A', '#F56C6C']"
        class="item-center flex-row"
        disabled
      />
      <span class="label_tag">{{ project['项目状态'] }}</span>
      <span v-if="project['独家']" class="label_tag">独家</span>
      <span v-if="showAdvanced(project)" class="label_tag">高端</span>
      <span v-if="project['新增']" class="label_tag">新增</span>
      <span v-if="project['替代']" class="label_tag">替代</span>
      <span v-if="project['保密']" class="label_tag">保密</span>
      <template v-if="hasPermisson(project)">
        <el-dropdown class="mr5" trigger="click">
          <el-button plain type="primary" size="mini">
            项目操作 <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="project['客户公司']" @click.native="showCompany(project['客户公司'])"
              >查看公司信息</el-dropdown-item
            >
            <el-dropdown-item @click.native="generatePic(project)">生成图片</el-dropdown-item>
            <el-dropdown-item @click.native="feedbackVisible = true">客户反馈</el-dropdown-item>
            <el-dropdown-item @click.native="addProjectRadish">添加项目人选</el-dropdown-item>
            <!-- <el-dropdown-item @click.native="openDrawer('radish')">从人才库选人</el-dropdown-item>
            <el-dropdown-item @click.native="openDrawer('project')">从同类项目选人</el-dropdown-item>
            <el-dropdown-item @click.native="openDrawer('targetCompany')">从目标公司选人</el-dropdown-item> -->
            <el-dropdown-item @click.native="openCvInfo">从历史推荐选人</el-dropdown-item>
            <!-- <el-dropdown-item @click.native="openDrawer('finalRadish')">项目复盘</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
        <span class="mr5">
          <el-button :loading="oneKeyMatchLoading" round type="danger" size="mini" @click="oneKeyMatch('1')"
            >一键匹配</el-button
          >
        </span>
        <span class="mr5">
          <el-button :loading="oneKeyMatchLoading" round type="danger" size="mini" @click="oneKeyMatch('2')"
            >二键匹配</el-button
          >
        </span>
        <span class="mr5">
          <el-button :loading="oneKeyMatchLoading" round type="danger" size="mini" @click="oneKeyMatch('3')"
            >三键匹配</el-button
          >
        </span>
        <span class="mr5">
          <el-button round type="danger" size="mini" @click="recommendMatch(project)">智能匹配</el-button>
        </span>
        <span class="mr5">
          <el-button round type="primary" size="mini" @click="openCvInfo">
            <el-tooltip class="item" effect="dark" content="在推荐历史中查找与当前项目职能模块相同的人" placement="top">
              <span> 相似推荐 <i class="el-icon-question"></i> </span>
            </el-tooltip>
          </el-button>
        </span>
      </template>
      <div v-if="onClose" class="propject_detail_info_close_btn" @click="close"><i class="el-icon-error" /></div>
    </div>
    <!-- <div class="col-0 propject_detail_info_handlers mb10 pd10">
      <span class="mr10">
        <el-button type="danger" size="mini" @click="showDialog()">客户特殊要求 ！</el-button>
      </span>
      <el-button type="primary" size="mini" @click="showDialog('智能填写')">智能填写</el-button>
    </div>-->
    <ProjectDetail
      :project="project"
      :interviewer="interviewer"
      :add-interviewer="addInterviewer"
      :new-add-project-editing="newAddProjectEditing"
      :edit-new-project-toggle="editNewProjectToggle"
      :save-new-project-edit="saveNewProjectEdit"
      :get-temporary-hrs="getTemporaryHrs"
      :get-interviewer="getInterviewer"
      :remove-question="removeQuestion"
      :add-question="addQuestion"
      :choose-new-radish="chooseNewRadish"
      :change-fields="changeFields"
      :update-project="updateProject"
      :cancel-edit="cancelEdit"
      :show-dialog="showDialog"
      :edit-project-field="editProjectField"
      :add-project-leader="addLeader2Project"
      :company-editing="companyEditing"
      :company="company"
      :files="files"
      :portrait-editing="portraitEditing"
      :company-collapsed="companyCollapsed"
      :leaders-editing="leadersEditing"
      :edit-portrait-toggle="editPortraitToggle"
      :edit-leaders-toggle="editLeadersToggle"
      :edit-company-toggle="editCompanyToggle"
      :add-project-h-r="addProjectHR"
      :remove-project-hr="removeProjectHr"
      :insert-company-hr-visible="insertCompanyHrVisible"
      :changes="changes"
      :upload="upload"
      :save-company="saveCompany"
      :interview-addr-input="interviewAddrInput"
      :interview-remark-input="interviewRemarkInput"
      :save-leaders="saveLeaders"
      :remove-project-leader="removeProjectLeader"
      :save-portrait-edit="savePortraitEdit"
      :category-obj="categoryObj"
      :show-company="showCompany"
      :edit-project-target-radishes="editProjectTargetRadishes"
      :add-project-tag="addProjectTag"
      :project-hrids="projectHrids"
      :show-add-company-leader-dialog="showAddCompanyLeaderDialog"
      :edit-project-fields="editProjectFields"
    />
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" :modal="false" @closed="onCancel">
      <div v-if="dialogTitle === '参与成员'">
        <div class="flex-row mb5">
          <div class="col-0 propject_detail_info_label mr5">客户开发</div>
          <div class="col-1 flex-row flex-wrap flex_wrap_container">
            <div v-for="(item, index) in changes['客户开发']" :key="index" class="flex_wrap_item">
              <el-select v-model="changes['客户开发'][index]" filterable size="mini">
                <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
              </el-select>
              <a class="col-0 mr5 danger" @click="removePartner('客户开发', index)"> <i class="el-icon-remove" /> </a>
              <a v-if="index === changes['客户开发'].length - 1" class="col-0 mr5" @click="addPartner('客户开发')">
                <i class="el-icon-circle-plus" />
              </a>
            </div>
          </div>
        </div>
        <div class="flex-row mb5">
          <div class="col-0 propject_detail_info_label mr5">项目对接</div>
          <div class="col-1 flex-row flex-wrap flex_wrap_container">
            <div v-for="(item, index) in changes['项目对接']" :key="index" class="flex_wrap_item">
              <el-select v-model="changes['项目对接'][index]" filterable size="mini">
                <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
              </el-select>
              <a class="col-0 mr5 danger" @click="removePartner('项目对接', index)"> <i class="el-icon-remove" /> </a>
              <a v-if="index === changes['项目对接'].length - 1" class="col-0 mr5" @click="addPartner('项目对接')">
                <i class="el-icon-circle-plus" />
              </a>
            </div>
          </div>
        </div>
        <div class="flex-row mb5">
          <div class="col-0 propject_detail_info_label mr5">项目经理</div>
          <div class="col-1 flex-row flex-wrap flex_wrap_container">
            <div v-for="(item, index) in changes['项目经理']" :key="index" class="flex_wrap_item">
              <el-select v-model="changes['项目经理'][index]" filterable size="mini">
                <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
              </el-select>
              <a class="col-0 mr5 danger" @click="removePartner('项目经理', index)"> <i class="el-icon-remove" /> </a>
              <a v-if="index === changes['项目经理'].length - 1" class="col-0 mr5" @click="addPartner('项目经理')">
                <i class="el-icon-circle-plus" />
              </a>
            </div>
          </div>
        </div>
        <div class="flex-row mb5">
          <div class="col-0 propject_detail_info_label mr5">项目成员</div>
          <div class="col-1 flex-row flex-wrap flex_wrap_container">
            <div v-for="(item, index) in changes['项目成员']" :key="index" class="flex_wrap_item">
              <el-select v-model="changes['项目成员'][index]" filterable size="mini">
                <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
              </el-select>
              <a class="col-0 mr5 danger" @click="removePartner('项目成员', index)"> <i class="el-icon-remove" /> </a>
              <a v-if="index === changes['项目成员'].length - 1" class="col-0 mr5" @click="addPartner('项目成员')">
                <i class="el-icon-circle-plus" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="dialogTitle === '目标人选'">
        <!-- <div v-else-if="dialogTitle === '目标人选' || dialogTitle === '领导介绍'"> -->
        <div v-if="dialogTitle === '目标人选'" class="flex-row flex-wrap item-center mb5">
          <div v-for="(value, i) in changes['目标人选']" :key="i" class="label_tag">{{ value.name }}</div>
        </div>
        <div class="drawer-tips ft-gray">
          人选关键词搜索的几种格式： 1、姓名； 2、姓名+空格+公司； 3、姓名+空格+公司+空格+部门； 4、手机号；
        </div>
        <el-input
          v-model="searchWords"
          placeholder="输入关键字，按回车搜索"
          size="mini"
          clearable
          @keyup.enter.native="searchRadishes"
        >
          <el-button slot="append" type="primary" icon="el-icon-search" size="mini" @click="searchRadishes"
            >搜索</el-button
          >
        </el-input>
        <p v-if="insertRadishVisible" style="text-align:center;">
          没有搜索到相关人选，点击 <a @click="insertRadish">新建</a>打开新建人选窗口
        </p>
        <el-table :max-height="450" :data="searchResult" size="mini" style="width: 100%">
          <el-table-column label="操作" width="60">
            <template slot-scope="scope">
              <a @click="onSelectRadish(scope.row)">选择</a>
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <div>
                <span class="drawer-link" @click="showRadishDetail(scope.row)">{{ scope.row['姓名'] }}</span>
              </div>
              <div style="color:#aaa">{{ scope.row['手机'] }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="公司" label="公司" />
          <el-table-column prop="部门" label="部门" />
          <el-table-column prop="目前职位" label="目前职位" />
        </el-table>
      </div>
      <div v-else-if="dialogTitle === '附件类型'">
        <el-select v-model="fileType" filterable placeholder="请选择文件类型">
          <el-option v-for="item in projectFileTypes" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div v-else-if="dialogTitle === '智能填写'">
        <p class="propject_detail_info_title">
          <span class="mr10">智能填写</span>
          <span class="mr10">
            <el-button type="primary" size="mini" @click="parseTemplateText()">解析</el-button>
          </span>
          <!-- <span class="mr10">
              <el-button type="primary" size="mini" @click="upload('', 1)">上传并解析</el-button>
          </span>-->
          <span class="mr10">
            <el-button type="primary" size="mini" @click="download({ url: `${host}/upload/项目信息模板.docx` })"
              >下载模板</el-button
            >
          </span>
          <span class="ft-gray ft-small"
            >1、下载模板 2、按照模板填写内容 3、将内容复制并粘贴至下面的文本框内 4、点击解析</span
          >
        </p>
        <el-input
          v-model="templateText"
          type="textarea"
          size="mini"
          placeholder="粘贴按照模板格式写好的文字内容，然后点击解析"
          :autosize="{ minRows: 2, maxRows: 6 }"
        />
      </div>
      <div v-else class="propject_detail_info_block">
        <div v-if="changeFields.includes('客户特殊要求')" class="propject_detail_info_block_handlers">
          <a class="mr5" @click="cancelEdit('客户特殊要求')">取消</a> <a @click="updateProject('客户特殊要求')">保存</a>
        </div>
        <i v-else class="el-icon-edit-outline" @click="editProjectField('客户特殊要求')" />
        <p class="propject_detail_info_title">客户特殊要求</p>

        <div class="display-flex mb10">
          <span class="keep-all">寻访：</span>
          <el-input
            v-if="changeFields.includes('特殊要求寻访')"
            v-model="changes['特殊要求寻访']"
            type="textarea"
            :placeholder="`例如：1、某些企业的人不能推荐；`"
          ></el-input>
          <pre v-else class="dialog-pre">{{ project['特殊要求寻访'] }}</pre>
        </div>
        <div class="display-flex mb10">
          <span class="keep-all">推荐：</span>
          <el-input
            v-if="changeFields.includes('推荐备注')"
            v-model="changes['推荐备注']"
            type="textarea"
            :rows="3"
            :placeholder="
              `例如：
1、推荐人选的期望薪资写在邮件正文，不能写在推荐报告；
2、推荐报告特殊模板；
3、简历推荐除了邮件之后要上系统，系统地址：http://www.wertyu.com.cn`
            "
          ></el-input>
          <pre v-else class="dialog-pre">{{ project['推荐备注'] }}</pre>
        </div>
        <div class="display-flex mb10">
          <span class="keep-all">面试安排：</span>
          <el-input
            v-if="changeFields.includes('面试安排')"
            v-model="changes['面试安排']"
            type="textarea"
            :rows="3"
            :placeholder="
              `例如：
    1、人选面试的时候要带身份证，公司楼下有门禁；
    2、面试安排要抄送人力加上业务领导；`
            "
          ></el-input>
          <pre v-else class="dialog-pre">{{ project['面试安排'] }}</pre>
        </div>
        <div class="display-flex mb10">
          <span class="keep-all">其他：</span>
          <el-input
            v-if="changeFields.includes('客户特殊要求')"
            v-model="changes['客户特殊要求']"
            type="textarea"
          ></el-input>
          <pre v-else class="dialog-pre">{{ project['客户特殊要求'] }}</pre>
        </div>

        <!-- <el-input
          v-if="changeFields.includes('客户特殊要求')"
          v-model="changes['客户特殊要求']"
          type="textarea"
          autosize
        />
        <pre v-else>{{ project['客户特殊要求'] }}</pre>-->
        <p class="propject_detail_info_title">
          相关附件 <a @click="upload('特殊要求')"> <i class="el-icon-circle-plus" /> </a>
        </p>
        <div class="propject_detail_info_table">
          <div class="flex-row project_table_thead">
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_0 propject_detail_info_label"
              >类型</span
            >
            <span
              class="propject_detail_info_table_cell propject_detail_info_files_cell_1 propject_detail_info_label col-1"
              >文件名</span
            >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_2 propject_detail_info_label"
              >上传时间</span
            >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_3 propject_detail_info_label"
              >上传人</span
            >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_4 propject_detail_info_label"
              >操作</span
            >
          </div>
          <div
            v-for="(file, i) in filesFilter('特殊要求')"
            :key="i"
            :class="`flex-row item-center ${i % 2 === 0 ? 'bg-gray' : ''}`"
          >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_0 col-0">{{ file.type }}</span>
            <a class="propject_detail_info_table_cell propject_detail_info_files_cell_1 col-1" @click="preview(file)">{{
              file.originalname
            }}</a>
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_2 col-0">{{
              file.createdAt ? dateFormat(new Date(parseInt(file.createdAt, 10)), 'yyyy-mm-dd') : '--'
            }}</span>
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_3 col-0">{{
              file.uploader
            }}</span>
            <a class="propject_detail_info_table_cell propject_detail_info_files_cell_4 col-0" @click="download(file)"
              >下载</a
            >
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <span class="mr10">
          <el-button size="mini" type="danger" @click="dialogVisible = false">取 消</el-button>
        </span>
        <el-button v-if="dialogTitle === '附件类型'" size="mini" type="primary" @click="upload()">下一步</el-button>
        <el-button v-else size="mini" type="primary" @click="onConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <UploadDialog ref="upload" :on-success="uploadSuccess" :type="fileType" :label="fileType" />

    <!-- 搜索人选弹窗 -->
    <serch-radish-dialog
      ref="serchRadishDialog"
      :could-insert="true"
      choose-btn-text="选择"
      :could-choose-more="true"
      @choose="chooseRadish"
      @chooseMore="chooseMoreRadish"
    ></serch-radish-dialog>

    <ProjectFeedback :visible.sync="feedbackVisible" :project="project" />
    <ProjectDetailEditor
      v-if="showEditor"
      :project-id="project._id"
      :show="showEditor"
      :on-close="() => (showEditor = false)"
      :on-project-updated="
        _project => {
          project = Object.assign({}, _project)
        }
      "
      :on-company-updated="
        _company => {
          company = Object.assign({}, _company)
        }
      "
      @getProject="getProject"
    />
    <!-- 关键面试决策人弹窗 -->
    <serch-radish-dialog
      ref="newAddProjectSearchRadish"
      :could-insert="true"
      choose-btn-text="选择"
      @choose="chooseNewRadish"
    ></serch-radish-dialog>
    <generatePic ref="generatePic" @closed="getProject" />
  </div>
</template>

<script>
import serchRadishDialog from '../../../company/src/component/serchRadishDialog.vue'
import ProjectFeedback from './ProjectFeedback.vue'
import ProjectDetailEditor from './ProjectDetailEditor.vue'
import ProjectDetail from './ProjectDetail.vue'
import generatePic from '../dialog/generatePic.vue'
import {
  oneKeyMatch,
  recommendMatch,
  arrRemove,
  download,
  hasPermisson,
  parseTemplateText,
} from '../constant/utils'
import { projectFileTypes } from '../constant/type'

// 组件已弃用
const defaultProject = {
  标签: [],
  对接hr: [],
}

const dateFormat = require('dateformat')

export default {
  components: {
    ProjectFeedback,
    ProjectDetailEditor,
    ProjectDetail,
    serchRadishDialog,
    generatePic,
  },
  props: {
    showTitle: { type: Boolean, default: true },
    projectId: { type: String, default: undefined },
    onClose: { type: Function, default: undefined },
  },
  data() {
    return {
      projectLoading: false,
      companyLoading: false,
      filesLoading: false,
      oneKeyMatchLoading: false,
      project: defaultProject,
      company: {},
      files: [],
      dialogVisible: false,
      dialogTitle: undefined,
      fileType: '',
      companyCollapsed: true,
      projectCollapsed: true,
      changes: {},
      portraitEditing: false,
      newAddProjectEditing: false,
      categoryObj: {},

      grabbingTagIndex: undefined,
      leaderName: undefined,
      leaderDesc: undefined,
      addLeaderVisible: false,
      searchResult: [],
      searchWords: '',
      selectedLeader: undefined,
      feedbackVisible: false,
      showEditor: false,
      companyEditing: false,
      interviewAddrInput: '',
      interviewRemarkInput: '',
      movetagindex: '',
      leadersEditing: false,
      confirmVisible: false,
      deletePeddingArr: [],
      insertCompanyLeaderVisible: false,
      leaderNameInput: '',
      leaderDescInput: '',
      insertRadishVisible: false,
      insertCompanyHrVisible: false,
      newCompanyHr: {},
      projectHrids: [],
      interviewer: [],
      templateText: '',
    }
  },
  computed: {
    dateFormat() {
      return dateFormat
    },
    host() {
      return window.host
    },
    recommendMatch() {
      return recommendMatch
    },
    changeFields() {
      return Object.keys(this.changes)
    },
    categories() {
      return window.app.categories || []
    },
    accounts() {
      return window.app.accounts || []
    },
    projectFileTypes() {
      return projectFileTypes
    },
    download() {
      return download
    },
    preview() {
      return preview
    },
    hasPermisson() {
      return hasPermisson
    },
  },
  watch: {
    projectId: {
      handler(newValue, oldValue) {
        if (newValue === oldValue) return
        this.getProject()
        this.company = {}
      },
      immediate: true,
    },
    changes: {
      handler(newValue, oldValue) {
        if (newValue && newValue['职能模块']) {
          const categoryObj = this.categories.find(category => newValue['职能模块'] === category['名称'])
          this.categoryObj = Object.assign({}, categoryObj)
        }
      },
      immediate: true,
      deep: true,
    },
    searchWords(newValue, oldValue) {
      this.insertRadishVisible = false
    },
  },
  async mounted() {
    if (!app.categories) {
      await app.getCats()
    }
    if (!app.accounts) {
      await app.getUsers()
    }
    this.btnReLocation()
  },
  methods: {
    async generatePic(project) {
      await app.service('project').saveRecords({ type: '生成图片', path: '顶部导航栏-项目操作', page: '项目详情' })
      this.$refs.generatePic.open(project)
    },
    editProjectFields(fields = []) {
      const obj = {}
      fields.forEach(field => {
        if (this.project[field] && typeof this.project[field] === 'object') {
          obj[field] = window._.cloneDeep(this.project[field])
        } else obj[field] = this.project[field] || ''
      })
      this.changes = obj
    },
    addInterviewer() {
      this.newinsertType = 'interviewer'
      this.$refs.newAddProjectSearchRadish.open()
    },
    async getTemporaryHrs() {
      const ids = this.project['项目对接hr']
      if (ids && ids.length !== 0) {
        const res = await app.service('radish').findByIds({ ids })
        this.temporaryHr = res.data
      } else this.temporaryHr = []
    },
    async getInterviewer() {
      const ids = this.newAddProjectEditing ? this.changes['关键面试人'] : this.project['关键面试人']
      if (ids && ids.length !== 0) {
        const res = await app.service('radish').findByIds({ ids })
        this.interviewer = res.data
      } else this.interviewer = []
    },
    chooseNewRadish(radish) {
      this.chooseInterviewer(radish)
      // if (this.newinsertType === 'interviewer') this.chooseInterviewer(radish)
      // else if (this.newinsertType === 'hr') this.chooseHr(radish)
    },
    chooseInterviewer(radish) {
      if (!this.changes['关键面试人']) this.$set(this.changes, '关键面试人', [])
      if (!this.changes['关键面试人'].includes(radish._id)) this.changes['关键面试人'].push(radish._id)
      this.getInterviewer()
    },
    chooseHr(radish) {
      if (!this.project['项目对接hr']) this.$set(this.project, '项目对接hr', [])
      if (!this.project['对接hr'].includes(radish._id) && !this.project['项目对接hr'].includes(radish._id))
        this.project['项目对接hr'].push(radish._id)
      this.getTemporaryHrs()
    },
    addQuestion() {
      if (!this.changes.关注问题) this.$set(this.changes, '关注问题', [])
      this.changes.关注问题.push('')
    },
    removeQuestion(index) {
      this.changes.关注问题.splice(index, 1)
    },
    showAdvanced(project) {
      const jobRank = project['职级'] || []
      return jobRank.includes('1') || jobRank.includes('2')
    },
    openCvInfo() {
      const cate = this.project.职能模块
      const query = cate ? JSON.stringify({ 职能模块: [cate] }) : ''
      window.open(`${window.origin}/#/cvinfo${query ? `/${query}/` : ''}`)
    },
    // 高高制作
    async showAddCompanyLeaderDialog() {
      let defaultSerchRadishes = []
      const res = await app.service('company').defaultSerchLeaders(this.company.简称)
      if (res.status == 'success') {
        defaultSerchRadishes = res.data
      } else {
        this.$message.error(res.msg)
      }
      this.$refs.serchRadishDialog.open({ 公司: this.company.简称 }, defaultSerchRadishes)
    },
    chooseMoreRadish(radishes) {
      for (const radish of radishes) {
        this.chooseRadish(radish)
      }
    },
    chooseRadish(radish) {
      const couldInsert = this.checkDuplicateLeader(radish)
      if (couldInsert) this.addCompanyLeader(radish)
      else this.$message.warning('该人选已添加，请勿重复操作')
    },
    checkDuplicateLeader(radish) {
      const result = this.company['领导'].find(leader => leader.rid === radish._id)
      return !result
    },
    async addCompanyLeader(radish) {
      const leader = { rid: radish._id, cid: this.company._id }
      try {
        const res = await app.service('project').addCompanyLeader(leader)
        if (!this.company['领导']) this.company['领导'] = []
        const companyLeader = {
          _id: res._id,
          rid: radish._id,
          姓名: radish.姓名,
          目前职位: radish.目前职位,
          简介: radish.简介,
        }
        this.company['领导'].push(companyLeader)
        this.addLeader2Project(res._id)
        this.$message({ type: 'success', message: '添加成功' })
      } catch (e) {
        this.$message.error(e)
      }
    },
    // 高高制作结束
    insertCompanyLeader() {
      this.leaderNameInput = ''
      this.leaderDescInput = ''
      this.insertCompanyLeaderVisible = true
    },
    insertRadish() {
      app.root.$refs.radishAdd && app.root.$refs.radishAdd.open({ 姓名: this.searchWords })
    },
    // async insertCompanyHr() {
    //   let defaultSearchRadishes = []
    //   const res = await app.service('company').defaultSearchHrs(this.company.简称)
    //   if (res.status == 'success') {
    //     defaultSearchRadishes = res.data
    //   } else {
    //     this.$message.error(res.msg)
    //   }
    //   this.$refs.serchRadishDialog.open({ 公司: this.company.简称 }, defaultSearchRadishes)

    //   // for (let key in this.newCompanyHr) {
    //   //   this.newCompanyHr[key] = ''
    //   // }
    //   // this.insertCompanyHrVisible = true
    // },
    async getProject() {
      this.projectLoading = true
      try {
        const project = await window.app.service('project').fetch(this.projectId)
        this.initProject(project)
        const { data } = await this.$axios.post(`${window.host}/projects/newPipelines`, {
          pids: [this.projectId],
        })
        this.project = Object.assign({}, defaultProject, project, data[0])

        if (Array.isArray(this.project.remark)) {
          const arr = window._.cloneDeep(this.project.remark)
          arr.sort((a, b) => b.createAt - a.createAt)
          this.project.remark = arr
        }
        this.projectHrids = this.project['对接hr'] || []
        this.getCompany(project['客户公司'])
        this.getProjectFiles(this.project._id)
        this.updateProjectStorage()
      } catch (error) {
        this.$message.error(error.message)
      }
      this.projectLoading = false
    },
    updateProjectStorage() {
      const mapObj = {
        职位JD: ['岗位职责', '岗位要求'],
        客户信息: ['核心要求', '面试流程', '关键面试人', '对接hr', '客户特殊要求'],
        寻访方向: ['寻访方向', '目标公司', '典型目标人选'],
        亮点优势: ['职位亮点及优势', '部门详情', '阿尔法认知'],
        人才画像: ['职能模块', '擅长方向', '目标行业', '平台', '职级', '业绩', '地域'],
      }
      const badgeFields = []
      Object.keys(mapObj).forEach(v => {
        badgeFields.push(...mapObj[v])
      })
      const storage = localStorage.getItem('projectHistory')
      let obj = {}
      try {
        obj = (storage && JSON.parse(storage)) || {}
      } catch (e) {
        console.log(e)
      }
      obj[this.project._id] = obj[this.project._id] || {}
      badgeFields.forEach(field => {
        obj[this.project._id][field] = this.project.修改历史 && this.project.修改历史[field]
      })
      localStorage.setItem('projectHistory', JSON.stringify(obj))
    },
    initProject(project = this.project) {
      if (
        project &&
        project['领导'] &&
        typeof project['领导'] === 'object' &&
        !Array.isArray(project['领导']) &&
        project['领导'].name
      ) {
        project['领导'] = [project['领导']]
      }
      const arrayFields = ['平台', '细分职能', '业绩', '擅长方向', '职级', '目标行业', '地域', '标签']
      arrayFields.forEach(val => {
        if (project[val]) {
          if (!Array.isArray(project[val])) project[val] = [project[val]]
        } else project[val] = []
      })
    },
    async getCompany(companyName) {
      if (!companyName) return
      this.companyLoading = true
      try {
        const { result } = await window.app.service('company').getCompany(companyName)
        this.company = Object.assign({}, result)
        this.company.对接hr = await this.hr2radish(result.对接hr)
        this.company.领导 = await this.leaders2radish(result.领导)
      } catch (e) {
        console.error(e)
      }

      this.companyLoading = false
    },
    async hr2radish(hrs) {
      const res = await app.service('company').getCompanyHr(hrs || [])
      if (res.status === 'success') return res.data
      else {
        this.$message(res.msg)
        return []
      }
    },
    async leaders2radish(leaders) {
      const res = await app.service('company').getLeaders(leaders || [])
      if (res.status === 'success') return res.data
      else {
        this.$message(res.msg)
        return []
      }
    },
    async getProjectFiles(projectId) {
      if (!projectId) {
        this.files = []
        return
      }
      this.filesLoading = true
      try {
        const { data } = await window.app.service('file').projectFiles({ query: { projectId } })
        this.files = data
      } catch (e) {
        console.error(e)
      }
      this.filesLoading = false
    },
    async oneKeyMatch(mode) {
      this.oneKeyMatchLoading = true
      try {
        await oneKeyMatch({
          mode,
          project: this.project,
          onNoResult: () => {
            this.$message('没有匹配结果')
          },
        })
      } catch (error) {
        this.$message.error(error.message)
      }
      this.oneKeyMatchLoading = false
    },
    showDialog(dialogTitle) {
      this.dialogVisible = true
      this.dialogTitle = dialogTitle
    },
    onCancel() {
      this.dialogVisible = false
      const dialogTitle = this.dialogTitle
      if (dialogTitle === '参与成员') {
        this.cancelEdit({
          客户开发: true,
          项目对接: true,
          项目经理: true,
          项目成员: true,
        })
      } else if (dialogTitle === '目标人选') {
        this.cancelEdit({ 目标人选: true })
      } else {
        this.cancelEdit({ 客户特殊要求: true })
      }
    },
    onConfirm() {
      const { changes, dialogTitle } = this
      if (dialogTitle === '参与成员') {
        this.updateProject({
          客户开发: (changes['客户开发'] && changes['客户开发'].filter(Boolean)) || [],
          项目对接: (changes['项目对接'] && changes['项目对接'].filter(Boolean)) || [],
          项目经理: (changes['项目经理'] && changes['项目经理'].filter(Boolean)) || [],
          项目成员: (changes['项目成员'] && changes['项目成员'].filter(Boolean)) || [],
        })
      }
      if (dialogTitle === '目标人选') {
        this.updateProject({
          目标人选: (changes['目标人选'] && changes['目标人选'].filter(Boolean)) || [],
        })
      }
      // if (dialogTitle === '领导介绍') {
      //   const selectedLeader = this.selectedLeader
      //   this.updateCompanyLeader(selectedLeader._id, {
      //     name: selectedLeader.name,
      //     description: selectedLeader.description,
      //   })
      // }
      this.dialogVisible = false
    },
    // async updateCompanyLeader(id, param) {
    //   if (!id) return
    //   if (param && param._id) delete param._id
    //   try {
    //     await window.app.service('project').updateCompanyLeader({
    //       id,
    //       param,
    //     })
    //     const changedLeader = this.company['领导'].find(leader => leader._id === id)
    //     if (!changedLeader) return
    //     Object.keys(param).map(field => {
    //       changedLeader[field] = param[field]
    //     })
    //     if (this.selectedLeader) this.selectedLeader = undefined
    //   } catch (e) {
    //     this.$message.error(e.message)
    //   }
    // },
    async uploadSuccess(response, file, fileList) {
      this.$refs.upload.visible()
      const res = response[0]
      try {
        await window.app.service('project').insertProjectFile([
          Object.assign(res, {
            type: this.fileType || '附件',
            projectId: this.project._id,
          }),
        ])
        this.getProjectFiles(this.project._id)
        this.$message({
          type: 'success',
          message: `上传成功`,
        })
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    upload(type) {
      if (type) this.fileType = type || '附件'
      this.$refs.upload.visible(true)
    },
    editProjectField(field) {
      if (field !== '客户特殊要求') {
        this.changes = Object.assign({}, this.changes, {
          [field]: this.project[field],
        })
      } else {
        const fields = ['特殊要求寻访', '推荐备注', '面试安排', '客户特殊要求']
        const obj = {}
        fields.forEach(val => (obj[val] = this.project[val]))
        this.changes = obj
      }
    },
    editCompanyToggle() {
      this.companyEditing = !this.companyEditing
      const company = this.company
      const changes = {
        一句话简介: company['一句话简介'] || '',
        公司亮点: {
          content: (company['公司亮点'] && company['公司亮点'].content) || '',
          keywords: (company['公司亮点'] &&
            company['公司亮点'].keywords &&
            window._.cloneDeep(company['公司亮点'].keywords)) || {
            人员整体素质高: false,
            压力小: false,
            固薪高: false,
            大平台: false,
            文化好: false,
            激励机制好: false,
            稳定: false,
            股东实力强: false,
          },
        },
        '业务特点/风格/资源来源': {
          content: (company['业务特点/风格/资源来源'] && company['业务特点/风格/资源来源'].content) || '',
          keywords: (company['业务特点/风格/资源来源'] &&
            company['业务特点/风格/资源来源'].keywords &&
            window._.cloneDeep(company['业务特点/风格/资源来源'].keywords)) || {
            A: false,
            B: false,
            C: false,
            D: false,
            E: false,
            F: false,
          },
        },
        面试安排: company['面试安排'] || '',
        部门情况: company['部门情况'] || this.project['部门情况'] || '',
        '薪酬/职级/奖金机制': company['薪酬/职级/奖金机制'] || '',
        // 面试地址: (company['面试地址'] && window._.cloneDeep(company['面试地址'])) || [],
      }
      if (this.companyEditing) {
        this.companyCollapsed = false
        this.changes = Object.assign({}, this.changes, changes)
      } else {
        this.companyCollapsed = true
        this.cancelEdit(changes)
      }
    },
    filesFilter(type) {
      const files = this.files
      if (!type) return files
      return files.filter(val => val.type === type || (val.response && val.response[0].type === type))
    },
    cancelEdit(params) {
      if (typeof params === 'string') {
        if (params !== '客户特殊要求') {
          delete this.changes[params]
        } else {
          const fields = ['特殊要求寻访', '推荐备注', '面试安排', '客户特殊要求']
          fields.forEach(val => {
            delete this.changes[val]
          })
        }
        delete this.changes[params]
      } else {
        const fields = Object.keys(params)
        fields.map(field => {
          delete this.changes[field]
        })
      }
      this.changes = Object.assign({}, this.changes)
    },
    async updateProject(params, cb) {
      if (!this.project._id) return
      let param = {}
      if (typeof params === 'string') {
        if (params !== '客户特殊要求') param = { [params]: this.changes[params] || null }
        else {
          const fields = ['特殊要求寻访', '推荐备注', '面试安排', '客户特殊要求']
          fields.forEach(val => {
            param[val] = this.changes[val] || null
          })
        }
      } else param = params || {}
      // const param =
      //   typeof params === 'string'
      //     ? {
      //         [params]: this.changes[params] || null,
      //       }
      //     : params
      try {
        if (Object.keys(param).length === 0 || !param) {
          return
        }
        await window.app.service('project').modify({
          id: this.project._id,
          param,
        })
        this.project = Object.assign({}, this.project, param)
        if (Object.keys(param).includes('客户公司')) this.getCompany(this.project['客户公司'])
        this.$emit('updateProject', this.project)
        cb && cb()
        this.cancelEdit(param)
        this.$message({
          type: 'success',
          message: `修改成功`,
        })
      } catch (e) {
        this.$message.error(`update project :${e.message}`)
      }
    },
    async updateCompany(params, cb) {
      if (!this.company._id) return
      const param =
        typeof params === 'string'
          ? {
              [params]: this.changes[params] || null,
            }
          : params
      try {
        await window.app.service('company').modifyCompany({
          query: { _id: this.company._id },
          data: param,
        })
        this.company = Object.assign({}, this.company, param)
        cb && cb()
        this.cancelEdit(param)
        this.$message({
          type: 'success',
          message: `修改成功`,
        })
      } catch (e) {
        this.$message.error(`update company :${e.message}`)
      }
    },
    editPortraitToggle() {
      this.portraitEditing = !this.portraitEditing
      this.searchWords = ''
      const project = this.project
      const changes = {
        职能模块: project['职能模块'] || '',
        业绩: project['业绩'] || [],
        细分职能: project['细分职能'] || [],
        职级: project['职级'] || [],
        擅长方向: project['擅长方向'] || [],
        地域: project['地域'] || [],
        目标行业: project['目标行业'] || [],
        平台: project['平台'] || [],
        标签: project['标签'] || [],
        人才画像补充: project['人才画像补充'] || '',
        // 目标公司备注: project['目标公司备注'] || '',
        // 不倾向公司备注: project['不倾向公司备注'] || '',
        // 目标人选备注: project['目标人选备注'] || '',
        // 阿尔法认知: project['阿尔法认知'] || '',
      }
      if (this.portraitEditing) {
        this.changes = Object.assign({}, this.changes, changes)
      } else {
        this.cancelEdit(changes)
      }
    },
    savePortraitEdit() {
      const changes = this.changes
      this.updateProject(
        {
          职能模块: changes['职能模块'] || '',
          业绩: changes['业绩'] || [],
          细分职能: changes['细分职能'] || [],
          职级: changes['职级'] || [],
          擅长方向: changes['擅长方向'] || [],
          地域: changes['地域'] || [],
          目标行业: changes['目标行业'] || [],
          平台: changes['平台'] || [],
          标签: changes['标签'] || [],
          人才画像补充: changes['人才画像补充'] || '',
        },
        () => {
          this.portraitEditing = !this.portraitEditing
        },
      )
    },
    editNewProjectToggle() {
      this.newAddProjectEditing = !this.newAddProjectEditing
      const project = this.project
      const changes = {
        关注问题: window._.cloneDeep(project['关注问题'] || []),
        面试流程: project['面试流程'] || '',
        关键面试人: window._.cloneDeep(project['关键面试人'] || []),
      }
      if (this.newAddProjectEditing) {
        this.changes = Object.assign({}, this.changes, changes)
      } else {
        this.cancelEdit(changes)
      }
      this.getInterviewer()
    },
    saveNewProjectEdit() {
      const changes = this.changes
      this.updateProject(
        {
          关注问题: changes['关注问题'] || [],
          面试流程: changes['面试流程'] || '',
          关键面试人: changes['关键面试人'] || [],
        },
        () => {
          this.newAddProjectEditing = !this.newAddProjectEditing
        },
      )
    },
    async addLeader(param, radish) {
      const leader = param
      if (!this.company['领导']) this.company['领导'] = []
      const hasdata = this.company['领导'].find(leader => leader.rid === radish._id)
      if (hasdata) return
      try {
        const res = await window.app.service('project').addCompanyLeader(leader)
        const item = Object.assign({}, res, { 姓名: radish.姓名, 目前职位: radish.目前职位, 简介: radish.简介 })
        this.company['领导'].push(item)
        this.addLeader2Project(res._id)
        this.$message({ type: 'success', message: '添加成功' })
      } catch (e) {
        this.$message.error(e)
      }
    },
    cancelAddLeader() {
      this.leaderName = ''
      this.leaderDesc = ''
      this.addLeaderVisible = false
    },
    async searchRadishes() {
      if (!this.searchWords) return
      if (!this.dialogVisible) {
        this.dialogVisible = true
        this.dialogTitle = '领导介绍'
      }
      try {
        const { data, status, msg } = await window.app.service('misc').searchEs({
          type: '人选',
          keywords: this.searchWords,
          fields: ['姓名', '拼音', '公司', '部门', '职能模块', '手机'],
          and: true,
        })
        if (status === 'success') {
          this.searchResult = data
          this.insertRadishVisible = data.length === 0
        } else {
          this.$message.error(msg)
        }
      } catch (e) {
        console.error(e)
      }
    },
    editLeader(leader) {
      this.searchWords = leader.name
      this.selectedLeader = {
        _id: leader._id,
        name: leader.name || '',
        description: leader.description || '',
      }
      this.showDialog('领导介绍')
      this.$nextTick(() => {
        this.searchRadishes()
      })
    },
    editPartners() {
      const project = this.project
      const fields = ['客户开发', '项目对接', '项目经理', '项目成员']
      fields.forEach(field => {
        const value = (project[field] && project[field].slice()) || ['']
        this.$set(this.changes, field, value)
        if (this.changes[field].length === 0) this.changes[field].push('')
      })
      this.showDialog('参与成员')
    },
    addPartner(field) {
      const value = this.changes[field] || []
      const length = value.length
      if (length === 0 || value[length - 1]) {
        value.push('')
      }
      this.changes = Object.assign({}, this.changes, { [field]: value })
    },
    removePartner(field, index) {
      const value = this.changes[field] || []
      value.splice(index, 1)
      if (value.length === 0) value.push('')
      this.changes = Object.assign({}, this.changes, { [field]: value })
    },
    async onSelectRadish(radish) {
      const dialogTitle = this.dialogTitle
      if (dialogTitle === '领导介绍') {
        const leader = {
          cid: this.company._id,
          rid: radish._id,
        }
        this.addLeader(leader, radish)
      }
      if (dialogTitle === '目标人选') {
        this.changes['目标人选'].push({
          name: radish['姓名'],
          rid: radish._id,
        })
      }
    },
    showRadishDetail(radish) {
      if (!radish || !radish._id) {
        this.$message('没有关联的人选')
        return
      }
      window.open(`${window.frontend}/#/radish-detail-blank/${radish._id}`, '_blank')
    },
    addProjectRadish() {
      window.app.root.$refs.radishAdd.open({ defaultPid: this.project._id })
    },
    openDrawer(type, project) {
      if (window.app.root.$refs.addRadishDrawer) {
        window.app.root.$refs.addRadishDrawer.openDrawer(type, project || this.project)
      }
    },
    showCompany(keywords) {
      window.app.root.search({
        type: '公司',
        keywords,
      })
    },
    saveCompany() {
      const changes = this.changes
      this.updateCompany(
        {
          一句话简介: changes['一句话简介'] || '',
          公司亮点: changes['公司亮点'] || {
            content: '',
            keywords: {
              人员整体素质高: false,
              压力小: false,
              固薪高: false,
              大平台: false,
              文化好: false,
              激励机制好: false,
              稳定: false,
              股东实力强: false,
            },
          },
          '业务特点/风格/资源来源': changes['业务特点/风格/资源来源'] || {
            content: '',
            keywords: {
              A: false,
              B: false,
              C: false,
              D: false,
              E: false,
              F: false,
            },
          },
          面试安排: changes['面试安排'] || '',
          // 部门情况: changes['部门情况'] || '',
          '薪酬/职级/奖金机制': changes['薪酬/职级/奖金机制'] || '',
          // 面试地址: changes['面试地址'] || [],
        },
        () => {
          this.companyEditing = false
        },
      )
      if (changes['部门情况']) {
        this.updateProject({ 部门情况: changes['部门情况'] })
      }
    },
    // addInterviewAddr() {
    //   if (!this.interviewAddrInput || !this.interviewAddrInput.trim()) return
    //   this.changes['面试地址'].push({
    //     地址: this.interviewAddrInput,
    //     备注: this.interviewRemarkInput,
    //   })
    //   this.interviewAddrInput = ''
    //   this.interviewRemarkInput = ''
    // },
    // removeInterviewAddr(index) {
    //   this.changes['面试地址'].splice(index, 1)
    // },
    editLeadersToggle() {
      this.leadersEditing = !this.leadersEditing
      this.searchWords = ''
      const company = this.company
      const changes = {
        领导介绍: company['领导介绍'],
        领导: (company['领导'] && window._.cloneDeep(company['领导'])) || [],
      }
      if (this.leadersEditing) {
        this.changes = Object.assign({}, this.changes, changes)
      } else {
        this.cancelEdit(changes)
      }
    },
    saveLeaders() {
      const changes = this.changes
      const company = this.company
      this.updateCompany({ 领导介绍: changes['领导介绍'] || '' }, () => {
        this.leadersEditing = false
      })
      // const leaders = changes['领导']
      // const oldLeaders = company['领导'] || []
      // leaders.map(leader => {
      //   const oldLeader = oldLeaders.find(_leader => _leader._id === leader._id)
      //   if (!oldLeader) return
      //   if (leader.description !== oldLeader.description || leader.name !== oldLeader.name) {
      //     this.updateCompanyLeader(leader._id, leader)
      //   }
      // })
    },
    async removeCompanyLeader(id, _index) {
      if (!id) return
      if (this.deletePeddingArr.includes(_index)) return
      this.deletePeddingArr.push(_index)
      try {
        await window.app.service('project').removeCompanyLeader(id)
        arrRemove(this.company['领导'], leader => leader._id === id)
        this.$message({
          type: 'success',
          message: '删除成功',
        })
      } catch (e) {
        this.$message.error(e.message)
      }
      arrRemove(this.deletePeddingArr, target => target === _index)
    },
    uploadRadishFile(rid) {
      this.toUploadRid = rid
      this.showDialog('领导附件上传')
    },
    async addLeader2Project(id) {
      console.log(id)
      console.log(this.project.leaderIds)
      if (!id) return
      if (!this.project.leaderIds) this.project.leaderIds = []
      const index = this.project.leaderIds.findIndex(leaderId => leaderId === id)
      if (index > -1) return
      this.project.leaderIds.push(id)
      this.updateProject({ leaderIds: this.project.leaderIds })
    },
    removeProjectLeader(id) {
      if (!id) return
      arrRemove(this.project.leaderIds, leaderId => leaderId === id)
      this.updateProject({ leaderIds: this.project.leaderIds })
    },
    showRadish(opts) {
      window.open(`${window.frontend}/#/radish-detail-blank/${opts.id}`, '_blank')
    },
    close() {
      const changeKeys = Object.keys(this.changes)
      if (changeKeys.length > 0) {
        this.$confirm('您有未保存的改动, 确定离开?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.onClose && this.onClose()
          })
          .catch(() => {})
      } else {
        this.onClose && this.onClose()
      }
    },
    btnReLocation() {
      if (this.$refs.propject_detail_secondary) {
        const { width } = this.$refs.propject_detail_secondary.getBoundingClientRect()
        const right = `${parseInt(width, 10) + 25}px`
        if (this.editBtnRight === right) return
        this.$refs.editBtn.style.right = right
        this.editBtnRight = right
      }
    },
    // async addHr() {
    //   try {
    //     const hr = JSON.parse(JSON.stringify(this.newCompanyHr))
    //     if (!this.company['对接hr']) this.company['对接hr'] = []
    //     this.company['对接hr'].push(hr)
    //     let result = await window.app.service('company').modifyCompany({
    //       query: { _id: this.company._id },
    //       data: { 对接hr: this.company['对接hr'] },
    //     })
    //     if (result.status === 200) {
    //       this.addProjectHR(hr)
    //       this.insertCompanyHrVisible = false
    //       this.$message({ type: 'success', message: '添加成功' })
    //     } else {
    //       this.$message.error(`修改失败:${result.msg}`)
    //     }
    //   } catch (e) {
    //     this.$message.error(e)
    //   }
    // },
    async addHrAndRadish() {
      await this.addHr()
      const radish = this.newCompanyHr
      if (!radish.手机) this.$message('请输入手机号')
      const duplicate = await app.service('company').gethrmessage(radish.手机)
      if (duplicate.status === 201) {
        radish.公司 = this.company.简称
        radish.职能模块 = ['HR-人力']
        radish.from = 'project'
        const res = await window.app.service('radish').insert(radish)
        if (res.status == 'success') {
          this.$message({
            message: '添加人选成功',
            type: 'success',
          })
        } else {
          this.$message.error(`${res.msg}`)
        }
      } else if (duplicate.status === 200) {
        const serchData = duplicate.data
        const option = {}
        for (const key in radish) {
          if (!serchData[key] && radish[key]) option[key] = radish[key]
        }
        if (Object.keys(option).length !== 0) {
          const res = await window.app.service('radish').modifyById({ _id: serchData._id, data: option })
          if (res.status == 'success') {
            this.$message({
              message: '修改人选成功',
              type: 'success',
            })
          } else {
            this.$message.error(`${res.msg}`)
          }
        }
      } else {
        this.$message.error(`查询错误，${duplicate.msg}`)
      }
    },
    async addProjectHR(value) {
      const hrid = value._id
      if (this.projectHrids && this.projectHrids.length > 0) {
        const exist = this.projectHrids.find(_hrid => _hrid === hrid)
        if (exist) return
      }
      try {
        await app.service('project').addProjectHR({ id: this.project._id, hrid })
        this.projectHrids.push(hrid)
        this.$message.success(`添加成功`)
      } catch (e) {
        this.$message.error(e.message)
      }

      // const hrid = `${value['姓名']}.${value['手机']}`
      // if (!hrid || !hrid.trim()) return
      // if (this.projectHrids && this.projectHrids.length > 0) {
      //   const exist = this.projectHrids.find(_hrid => _hrid === hrid)
      //   if (exist) return
      // }
      // try {
      //   await window.app.service('project').addProjectHR({
      //     id: this.project._id,
      //     hrid,
      //   })
      //   this.projectHrids.push(hrid)
      //   this.$message({
      //     type: 'success',
      //     message: `修改成功`,
      //   })
      // } catch (e) {
      //   this.$message.error(e.message)
      // }
    },
    async removeProjectHr(value) {
      const hrid = value._id
      try {
        await app.service('project').removeProjectHR({ id: this.project._id, hrid })
        const index = this.projectHrids.findIndex(_hrid => _hrid === hrid)
        if (index === -1) return
        this.projectHrids.splice(index, 1)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    editProjectTargetRadishes() {
      this.changes = Object.assign({}, this.changes, {
        目标人选: (this.project['目标人选'] && this.project['目标人选'].slice()) || [],
      })
      this.showDialog('目标人选')
    },
    addProjectTag(value) {
      const changeTags = this.changes['标签'].slice()
      changeTags.push(value)
      this.changes = Object.assign({}, this.changes, { 标签: changeTags })
    },
    parseTemplateText(_json) {
      const json = _json || parseTemplateText(this.templateText)
      const parseResult = {}
      const project = Object.assign({}, this.project)
      for (const key in json) {
        if (json.hasOwnProperty(key)) {
          const value = json[key]
          if (['目标公司', '目标人选'].includes(key)) {
            project[`${key}备注`] = value
          } else if (['平台', '业绩', '职级', '地域', '目标行业', '办公地'].includes(key) && typeof key === 'string') {
            project[key] = value.split(';').filter(Boolean)
          } else {
            project[key] = value
          }
          parseResult[key] = value
        }
      }
      this.project = Object.assign({}, project)
      this.initProject()
      this.parseResultVisible = true
      this.parseResult = Object.assign({}, parseResult)
    },
  },
}
</script>

<style>
@import '../css/main.css';
</style>
